module.exports = __webpack_public_path__ + "static/img/img_chanyebuju.f962dbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/img_chanyebuju.png
// module id = m0cm
// module chunks = 1